import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { ReturnCurrentUserDelegationCommand } from "../../../subscriptions/models/return-current-user-delegation-command.model";
import { SubscriptionsActions } from "../../../subscriptions/states/subscriptions.actions";
import { SubscriptionsSelectors } from "../../../subscriptions/states/subscriptions.selectors";

export interface PermitReturnDelegationConfirmationModalComponentData extends ReturnCurrentUserDelegationCommand {}

@Component({
    selector: "pmt-permit-return-delegation-confirmation-modal",
    templateUrl: "./permit-return-delegation-confirmation-modal.component.html",
    styleUrls: ["./permit-return-delegation-confirmation-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitReturnDelegationConfirmationModalComponent extends BaseModalComponent {
    public data!: PermitReturnDelegationConfirmationModalComponentData;

    public SubscriptionsActions = SubscriptionsActions;

    @Select(SubscriptionsSelectors.returnCurrentUserDelegationErrorMessage)
    public errorMessage$!: Observable<string | undefined>;

    constructor(private store: Store) {
        super();
    }

    public close(): void {
        this.closeModal();
    }

    public confirm(): void {
        if (!this.data?.returnIssuerDelegation && !this.data?.returnSuperintendentDelegation) {
            return;
        }

        this.store.dispatch(new SubscriptionsActions.ReturnCurrentUserDelegation(this.data)).subscribe(() => {
            const succeeded = this.store.selectSnapshot(SubscriptionsSelectors.returnCurrentUserDelegationSucceeded);
            if (succeeded) {
                this.closeModal();
            }
        });
    }
}
